import { IconButton, TableCell, TableRow } from '@material-ui/core'
import React from 'react'
import { ChevronUp, ChevronDown } from 'react-feather'
import { TableHeaderTitleCell } from '../system-container/report/TableHeaderTitleCell'
import { useTableStyles } from './use-table-styles'

type Props = {
  title: string
  values: string[]
  open?: boolean
  setOpen?: (open: boolean) => void
}

export function ResultsTableHeaderRow(props: Props): React.ReactElement {
  const { title, values, open, setOpen } = props
  const classes = useTableStyles()

  return (
    <TableRow>
      {setOpen !== undefined ? (
        <TableHeaderTitleCell title={title}>
          <IconButton onClick={() => setOpen(!open)}>
            {open ? <ChevronUp /> : <ChevronDown />}
          </IconButton>
        </TableHeaderTitleCell>
      ) : (
        <TableHeaderTitleCell title={title} />
      )}
      {values.map((value) => (
        <TableCell
          key={`results-header-${value}`}
          className={classes.versionHeaderCell}
          align="center"
        >
          {value}
        </TableCell>
      ))}
    </TableRow>
  )
}
